// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/AddAction/OAuth2/Processing/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_AddAction_OAuth2_Processing($connection_id: uuid!) {
  apps_connections_by_pk(id: $connection_id) {
    id
    status
  }
}

`